import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { LoadingOverlay } from '../../../../../core/screens/LoadingOverlay/LoadingOverlay';
import { AppState } from '../../../../../stores/redux-store';
import { useCreateTransfer as useCreateTransferImport } from '../../../hooks/useCreateTransfer/useCreateTransfer';

export type SessionTransferOwnProps = {
  useCreateTransfer?: typeof useCreateTransferImport;
};

export type SessionTransferProps = SessionTransferOwnProps;

export const SessionTransfer: React.FC<SessionTransferProps> = ({
  useCreateTransfer = useCreateTransferImport,
}) => {
  const sourceAccountNumber = useSelector(
    (state: AppState) => state.session.data?.sourceAccountNumber
  );

  const credentialsId = useSelector((state: AppState) => state.credentials.data?.id);
  const { createTransfer } = useCreateTransfer();

  useEffect(() => {
    if (credentialsId) {
      createTransfer({
        sourceUri: sourceAccountNumber,
        credentialsId,
      });
    }
  }, [createTransfer, sourceAccountNumber, credentialsId]);

  return <LoadingOverlay />;
};
